import React from 'react';
import { ChevronDown, ChevronUp, Info, TrendingUp, Shield, Activity, GitBranch, Target } from "lucide-react";

const features = [
  {
    id: 'trailing_trend',
    icon: <TrendingUp className="w-4 h-4 text-indigo-400 shrink-0" />,
    title: '다이내믹 트레일링 스탑',
    summary: '목표가 도달 시 바로 청산하지 않고 추세를 끝까지 쫓아갑니다',
    note: '지원 전략: ZL-MACD, MACD-EMA, H-MACD (그 외 전략은 무시됨)',
    noteStyle: 'indigo'
  },
  {
    id: 'profit_peak',
    icon: <Shield className="w-4 h-4 text-amber-400 shrink-0" />,
    title: '수익 정점 보호 (Profit Peak Protection)',
    summary: 'Mode 1: 시간 기반 콜백 — Mode 2: 고점 기반 절대 청산',
    note: null,
    noteStyle: 'amber'
  },
  {
    id: 'pnl_trailing',
    icon: <Activity className="w-4 h-4 text-cyan-400 shrink-0" />,
    title: '트레일링 스탑 (PnL Trailing Stop)',
    summary: '최고 수익 대비 콜백 시 청산 — 모든 전략 공통',
    note: null,
    noteStyle: 'cyan'
  },
  {
    id: 'mtf_early',
    icon: <GitBranch className="w-4 h-4 text-rose-400 shrink-0" />,
    title: '하위 프레임 조기 청산 (MTF Early Exit)',
    summary: '봉 마감 전이라도 5분봉에서 반대 크로스 감지 시 손실을 최소화해 조기 청산합니다',
    note: '지원 전략: ZL-MACD (실전/페이퍼 모드에서만 작동, 백테스트 제외)',
    noteStyle: 'rose'
  },
  {
    id: 'symbol_overrides',
    icon: <Target className="w-4 h-4 text-emerald-400 shrink-0" />,
    title: '코인별 개별 TP/SL 설정 (Symbol Overrides)',
    summary: '특정 코인에 대해 기본 설정을 무시하고 개별 TP/SL(%)을 적용합니다',
    note: null,
    noteStyle: 'emerald'
  }
];

export const SignalSidePanelFeatures: React.FC = () => {
  const [openFeatureId, setOpenFeatureId] = React.useState<string | null>(null);

  return (
    <div className="divide-y divide-border/50">
      {features.map((item) => (
        <div key={item.id} className="transition-all">
          <div
            className="p-4 flex items-center justify-between cursor-pointer select-none hover:bg-muted/10 transition-all gap-3"
            onClick={() => setOpenFeatureId(openFeatureId === item.id ? null : item.id)}
          >
            <div className="flex items-start gap-3 min-w-0">
              <div className="mt-0.5">{item.icon}</div>
              <div className="min-w-0">
                <h4 className="text-xs font-black text-foreground">{item.title}</h4>
                <p className="text-[10px] text-muted-foreground font-medium mt-0.5 leading-relaxed">{item.summary}</p>
              </div>
            </div>
            <button type="button" className="h-7 w-7 p-0 rounded-full hover:bg-muted/30 shrink-0 flex items-center justify-center">
              {openFeatureId === item.id
                ? <ChevronUp className="w-3.5 h-3.5 text-muted-foreground" />
                : <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />
              }
            </button>
          </div>
          {openFeatureId === item.id && item.note && (
            <div className="px-4 pb-4 animate-in fade-in-50 duration-200">
              {(item.noteStyle === 'indigo' && (
                <div className="flex items-center gap-1.5 text-[9px] font-bold text-indigo-400/80 bg-indigo-500/5 rounded-lg px-2.5 py-1.5">
                  <Info className="w-3 h-3" />
                  {item.note}
                </div>
              )) || (item.noteStyle === 'rose' && (
                  <div className="flex items-center gap-1.5 text-[9px] font-bold text-rose-400/80 bg-rose-500/5 rounded-lg px-2.5 py-1.5">
                    <Info className="w-3 h-3" />
                    {item.note}
                  </div>
                )) || (
                  <div className="flex items-center gap-1.5 text-[9px] font-bold text-muted-foreground/80 bg-muted/30 rounded-lg px-2.5 py-1.5">
                    <Info className="w-3 h-3" />
                    {item.note}
                  </div>
                )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
